






























































































import { Component, Model, Prop, Vue } from "vue-property-decorator";
import { BPagination } from "bootstrap-vue";
import "bootstrap-vue/dist/bootstrap-vue.css";

@Component({
  components: {
    BPagination,
  },
})
export default class GapPager extends Vue {
  @Prop(Number) readonly pageLength!: Number;
  @Prop(Number) readonly pageNumber!: Number;
  @Prop(Number) readonly rowsPerPage!: Number;
  @Prop(Number) readonly rowsTotal!: Number;
  setPage(page) {
    this.$emit("page-changed", page);
  }
  setRowsPerPage(e) {
    this.$emit("rows-per-page-changed", Number(e.target.value));
  }
}
